angular.module('tgaApp').service('URLParamsService', [
  '$http',
  '$location',
  function ($http, $location) {
    this.userParams = {
      bypass_reg: $location.search().bypass_reg,
      display_name: $location.search().display_name,
      username: $location.search().username,
      email: $location.search().email,
      initials: $location.search().initials,
      first_name: $location.search().first_name,
      last_name: $location.search().last_name,
      phone: $location.search().phone,
      employee_id: $location.search().employee_id,
      organization: $location.search().organization,
      country: $location.search().country,
      language: $location.search().language,
      segment: $location.search().segment,
      return_url: $location.search().return_url,
      event_mode: $location.search().event_mode,
      hub_id: $location.search().hub_id,
      challenge_id: $location.search().challenge_id,
    };

    this.siteParams = {
      token: $location.search().token,
      slug: $location.path() ? $location.path().substring(1) : null,
    };

    this.getUserParams = function () {
      return this.userParams;
    };

    this.getSiteParams = function () {
      return this.siteParams;
    };

    this.setDefaults = function () {
      if (!this.userParams.display_name) {
        if (!this.userParams.initials && !this.userParams.first_name) {
          this.userParams.display_name = null;
        } else {
          this.userParams.display_name = this.userParams.first_name
            ? this.userParams.first_name
            : this.userParams.initials;
        }
      }

      if (!this.userParams.username) {
        if (!this.userParams.email) {
          this.userParams.username = null;
        } else {
          this.userParams.username = this.userParams.email;
        }
      }

      if (!this.userParams.bypass_reg) {
        this.userParams.bypass_reg = false;
      }
    };

    this.setDefaults();
  },
]);
